import React, { useState, useEffect, useRef } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import useAnalytics from '~/utils/analytics'
import { useSwipeable } from 'react-swipeable'
import PlpInit from '~/initializers/plp-init'
import { imgSize, altText, jnstyls, compact } from '~/utils/helpers'

import Tile from '~/components/tile/tile'
import TilePk from '~/components/tile/tile-pk'
import TilePage from '~/components/tile/tile-page'

import * as tiless from "~/styles/tiles/tile.module.scss"
import * as styles from "~/styles/testing/search-tiles.module.scss"


const SearchTiles = ({ searchType, val }) => {
  const { gender, isMobile, setQuick, setSearch } = useTheme()
  const { fillCollection } = PlpInit()

  const [currGend, setCurrGend] = useState(null)
  const [showing, setShowing] = useState(null)
  const [collections, setCollections] = useState(null)
  const [height, setHeight] = useState(null)

  const tilesRef = useRef(null)
  const headRef = useRef(null)

  const getJson = async (handle) => {
    const response = await fetch(`/page-data/collections/${handle}/page-data.json`)
    const data = await response.json()
    if (!data?.result?.data?.collection) return

    return fillCollection(data?.result?.data?.collection)
  }

  const getColls = async () => {
    const men = await getJson('mens-search-collection')
    const women = await getJson('womens-search-collection-1')
    setCollections({men, women})
  }

  const checkHeight = () => {
    const hheight = document.querySelector('[shead]').getBoundingClientRect().height
    let newh = window.innerHeight - (1.5 * 26) - hheight - 45.23
    setHeight(newh)
  }

  const getGend = () => {
    return gendEnum[searchType] || gender.pgGender
  }

  const gendEnum = {
    m: "men",
    w: "women"
  }

  const pickColl = () => {
    const gend = getGend()
    if (gend === currGend) return

    const coll = collections[gend]
    const prod_ids = coll.prods_coll
    coll.prods_pk.forEach(x => x.pl_pima = 99998)
    const products = compact(prod_ids.map(id => 
      coll.products.find(x => x?.mid === id) || coll.prods_pk.find(x => x?.mid === id)
    ))

    setCurrGend(gend)
    setShowing(products)
  }

  const handleQuick = (handle, variant=false) => {
    const coll = collections[currGend]
    let product = coll.products.find(x => x.handle === handle)
    if (product) {
      let quick_prods = coll.products.filter(x => x?.pl_pima === product.pl_pima)
      let obj = {selected: product.shop_id, products: quick_prods}
      if (variant) obj['variant'] = variant

      window._conv_q = window._conv_q || []
      window._conv_q.push(["triggerConversion", "100458750"])
      setQuick(obj)

      if (variant) return
      // Quick view general
    }
  }

  useEffect(() => {
    if (!!collections) return
    getColls()

    window.addEventListener('resize', checkHeight, { passive: true })
    return () => {
      window.removeEventListener('resize', checkHeight)
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (showing) return
    if (!(collections?.men && collections?.women)) return
    pickColl()
    checkHeight()
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collections])

  useEffect(() => {
    if (!showing) return
    if (!(collections?.men && collections?.women)) return
    pickColl()
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gender, searchType])

  if (!showing || val) return (<></>)
 
  return (
    <div className={styles.search_tiles}>
      <div className={styles.head} sthead=''>
        {getGend()}'s Best Sellers
      </div>
      <div className={styles.tiles} ref={tilesRef} style={{maxHeight: `${height}px` || ''}}>
        {height && showing.map((product,index) => 
          <React.Fragment key={product.mid}>
            {product.pl_pima !== 99998 ? (
              <TilePage 
                product={product} 
                tile_ind={index} 
                page_type={'search test collection'} 
              />
            ) : (
              <div 
                className={jnstyls([tiless.tile, tiless.info_tile ])}
                id={product.mid}
                handle={product.handle}
                tile=""
              >
                <TilePk product={product} tile_ind={index} isInView={true} />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}



// <Tile 
//   product={product} 
//   tile_ind={index} 
//   is_plp={false} 
//   flats={getGend() === 'women' ? 'model' : 'flat'} 
//   show={true} 
//   handleQuick={handleQuick} 
// />


export default SearchTiles






